<template>
</template>

<script>
import Axios from 'axios';

    export default {
        data() {
            return {
                show: false,
                showW9: false
            }
        },
        mounted() {
            // console.log('Component mounted.')
        },
        methods: {
            // goBack(){
            //     var t = window.location.href;
            //     t = t.substr(0, t.lastIndexOf("/"));
            //     window.location.href = t;
            // }
            download(doc = null) {
                doc ? this.showW9 = true : this.show = true;
                // this.show = true;
            },

            toggleEmr (emr, coder) {
                Axios.patch(`/site_admins/coders/toggle_emr`, {emr: emr, coder: coder})
                .then((data) => {
                    console.log(data);
                });
            }
        }
    }
</script>